<div class="container">
  <app-steps [current]="stepAtual()" [total]="totalSteps()"></app-steps>
  <div class="mt-3">
    <h2>Escolha seu Instituto Previdenciário</h2>
    <p class="top-16">
      Veja abaixo as opções disponíveis de Instituto para você. <a href="https://www.vivest.com.br/site/paginas/home" target="_blank">Como funciona o Instituto Previdenciário</a>?
    </p>
  
    <div class="radio-card-container top-64">
      <div class="radio-card-column">
        <app-radio-card
          title="Resgate"
          description="Você recebe o valor disponível para resgate e encerra o vínculo com o plano, conforme as regras do regulamento e a tributação aplicável."
          value="1"
          name="instituto"
          [disabled]="desabilitado()[1]"
          [checked]="institutoSelecionado() === '1'"
          (selected)="institutoSelecionado.set($event)"
        ></app-radio-card>
  
        <app-radio-card
          title="Benefício Proporcional Diferido (BPD)"
          description="Você deixa os recursos no plano, sem fazer as contribuições regulares, para receber um benefício no futuro."
          value="3"
          name="instituto"
          [disabled]="desabilitado()[3]"
          [checked]="institutoSelecionado() === '3'"
          (selected)="institutoSelecionado.set($event)"
        ></app-radio-card>
      </div>
  
      <div class="radio-card-column">
        <app-radio-card
          title="Autopatrocínio"
          description="Você mantém o vínculo com o plano e continua contribuindo, assumindo também as contribuições que eram feitas pela empresa."
          value="2"
          name="instituto"
          [disabled]="desabilitado()[2]"
          [checked]="institutoSelecionado() === '2'"
          (selected)="institutoSelecionado.set($event)"
        ></app-radio-card>
  
        <app-radio-card
          title="Portabilidade"
          description="Você transfere os recursos para outro plano de previdência, conforme as regras aplicáveis, e continua investindo na sua aposentadoria."
          value="4"
          name="instituto"
          [disabled]="desabilitado()[4]"
          [checked]="institutoSelecionado() === '4'"
          (selected)="institutoSelecionado.set($event)"
        ></app-radio-card>

        @if (portabilidadeSelecionada()) {
          <p class="opcao-mensagem" role="status">
            <vivest-icon name="info" aria-hidden="true"></vivest-icon>
            <span>Para seguir com o processo de portabilidade, entre em contato com a central de atendimento da Vivest.</span>
          </p>
        }
      </div>
    </div>
  
    <div class="d-flex justify-content-center align-items-center buttons top-64">
      <vivest-button variant="outline" size="md" (click)="onReturn()">
        Voltar
      </vivest-button>
      <vivest-button variant="primary" size="md" [disabled]="!podeContinuar()" (click)="onSubmit()">
        <vivest-icon slot="icon-right" name="arrow-right" source="feather"></vivest-icon>
        Continuar
      </vivest-button>
    </div>
  </div>
</div>